module.exports = function () {
  this.app.$on('guestMode', event => {
    let phone = event.countryCode + event.phone
    if (phone.indexOf('+') === -1) phone = `+${phone}`
    this.sdk.post('/auth/guest', {
      email: event.email,
      device: this.session.token,
      firstName: event.firstName,
      lastName: event.lastName,
      phone: phone,
      wheelchair: event.wheelChair,
      serviceDog: event.serviceDog,
      brandID: this.brandID,
      deviceType: 'web',
      countryCode: event.countryCode,
      nationalNumber: event.phone,
      d2d: 1
    }, res => {
      if (!res.error) {
        res.token = this.session.token
        res.mobile = event.phone
        res.dialCode = event.countryCode
        this.app.user = res
        this.app.flash = {}
        res.action = 'guest'
        this.app.$emit('signupSuccess', res)
      } else {
        this.app.user = null
        this.app.flash = { type: 'signup', message: res.error.message }
        let emitData = {
          message: res.error.message,
          email: event.email,
          action: 'guest'
        }
        this.app.$emit('signupFailure', emitData)
      }
    }, '/1.1')
  })
}



// WEBPACK FOOTER //
// ./src/events/guest-mode.js